import { Address, BulkyItemSchedulerPayload, ContactInformation } from "src/interfaces";
import { http } from "./http";
import { createSession } from "./session";

export const loadScheduledItem = async (id: string, vendorUrl: string) => {
  const response = await http.get(`/bulkyScheduler/city/summary/${id}`);
  createSession(response.headers.authorization, { vendorUrl });
  return response.data;
};

export const saveScheduledItem = (data: BulkyItemSchedulerPayload) =>
  http.post("/bulkyScheduler/city/schedulePickup", data).then((response) => {
    return response.data && response.data.confirmationIdentifier;
  });

export const cancelScheduledItems = (ids: number[], confirmationId: string) =>
  http.delete(`/bulkyScheduler/city/schedulePickup/${confirmationId}/bulkyItems/cancellation`, {
    data: ids,
  });

export const validateAddress = (address: Address) =>
  http
    .post("/bulkyScheduler/city/customer/address", {
      ...address,
    })
    .then((response) => {
      return response.data;
    });

export const updateContactInfo = (confirmationId: string, contactInfo: ContactInformation) =>
  http
    .post(`/bulkyScheduler/city/updateContactInfo/${confirmationId}`, {
      ...contactInfo,
    })
    .then((response) => response.data);

export const loadPickupsInZone = (zoneId: number, locationId?: number) =>
  http
    .get("/bulkyScheduler/city/pickupsInZone", { params: { zoneId, locationId } })
    .then((response) => {
      return response.data;
    });
